export default function<T extends Record<string, any>, K extends keyof T>(
  object: T,
  keys: K | K[],
): Pick<T, K> {
  const _keys = Array.isArray(keys) ? keys : [keys];

  return Object.keys(object).reduce((acc, key) => {
    if (_keys.includes(key as K)) {
      (acc as any)[key as K] = object[key];
    }
    return acc;
  }, {} as Pick<T, K>);
}
